import { render, staticRenderFns } from "./010_NSC_Anim.vue?vue&type=template&id=1216674a&scoped=true&"
import script from "./010_NSC_Anim.vue?vue&type=script&lang=js&"
export * from "./010_NSC_Anim.vue?vue&type=script&lang=js&"
import style0 from "./010_NSC_Anim.vue?vue&type=style&index=0&id=1216674a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1216674a",
  null
  
)

export default component.exports